import DOMPurify from "dompurify";

export const sanitizeHtml = (html?: string | null): string => {
  if (!html) return "";
  return DOMPurify.sanitize(html);
};